/**
 * User preferences and per-interface config API.
 */

import apiClient from './api-client';
import type { UserPreferences } from '@/types/preferences.types';

/** `GET /user-preferences` */
export const getUserPreferences = async (): Promise<UserPreferences> => {
  const { data } = await apiClient.get('/user-preferences');
  return data;
};

/** `PUT /user-preferences` */
export const updateUserPreferences = async (
  preferences: Partial<Pick<UserPreferences, 'isDarkMode' | 'interfaceConfigs'>>,
): Promise<UserPreferences> => {
  const { data } = await apiClient.put('/user-preferences', preferences);
  return data;
};

/** `PATCH /user-preferences/interface/:name` */
export const updateInterfaceConfig = async (
  interfaceName: string,
  config: Record<string, unknown>,
): Promise<UserPreferences> => {
  const { data } = await apiClient.patch(`/user-preferences/interface/${interfaceName}`, {
    config,
  });
  return data;
};
